import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import type { ProviderProductType } from "../../admin/providers/providersApi";
import type { InvoiceSellerId } from "../../orders/ordersApi";
import { sellerByProductType } from "../sellerByProductType";

export function ProductInfoDialog(props: {
  product: {
    name: string;
    providerProductType?: ProviderProductType;
    description?: string;
  };
  onClose(): void;
}) {
  return (
    <Dialog open={true} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <InfoOutlinedIcon color="primary" />
        Informacje o produkcie
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" gutterBottom>
          {props.product.name}
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
          Dostawca: <strong>{sellerLabel[sellerByProductType(props.product.providerProductType)]}</strong>
        </Typography>
        {props.product.description && <Typography variant="body1">{props.product.description}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Zamknij</Button>
      </DialogActions>
    </Dialog>
  );
}

const sellerLabel: Record<InvoiceSellerId, string> = {
  B2B_HOTELS: "B2Bhotels",
  PRZEZMORZE: "Przezmorze.pl",
};
